module.exports = __webpack_public_path__ + "img/17.3e8d5b3d.jpg";